import React, { useEffect } from 'react'
import { Typography, Box, Grid, Divider, Card, CardMedia, CardContent, Paper } from '@mui/material'
import { Dialog, DialogTitle, DialogContent } from '@mui/material'
import _ from "lodash"
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { useDispatch, useSelector } from 'react-redux'
import { fetchHealthShelfs, selectHealthShelfById } from '../../../reducers/healthshelf_single'
import { useSearchParams } from 'react-router-dom'


const ArticleDialog = (props) => {
    const Article = props.Article
    const { user: currentUser } = useSelector((state) => state.auth);
    const dispatch = useDispatch()
    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }



    return (
        <Paper elevation={1} style={{ marginTop: '150px', padding: '40px' }}>
            <Grid container direction="row" alignItems="top" justifyContent="center" spacing={2}>
                <Grid item xs={12}>


                    <Grid container direction="row" alignItems="top" justifyContent="center" spacing={2}>
                        <Grid item xs={12} md={3}>
                            <Box
                                component="img"
                                src={"../" + Article.Image + "/"}
                                alt={Article.ComponentValues.TitleBlock.Title}
                                sx={{
                                    height: "auto",
                                    width: "100%",

                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Grid container direction="row" alignItems="top" justifyContent="center" spacing={2}>

                                <Grid item xs={12} m={1}>
                                    <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2, m: 1 }} />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="h4" align="center">{Article.ComponentValues.TitleBlock.Title}</Typography>
                                </Grid>
                                <Grid item xs={12} m={1}>
                                    <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2, m: 1 }} />
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <Typography ml={1} variant="body1" dangerouslySetInnerHTML={{ __html: _.unescape(Article.ComponentValues.LeadIn) }}></Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography ml={1} variant="body1" dangerouslySetInnerHTML={{ __html: _.unescape(Article.ComponentValues.Body) }}></Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography ml={1} variant="body1" dangerouslySetInnerHTML={{ __html: _.unescape(Article.ComponentValues.LeadOut) }}></Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2, m: 1 }} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Typography ml={1} variant="caption" dangerouslySetInnerHTML={{ __html: _.unescape(Article.ComponentValues.References.replace(/(?:\r\n|\r|\n)/g, "")) }}></Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2, m: 1 }} />
                    </Grid>
                </Grid>
            </Grid>
        </Paper>

    )

}


export default ArticleDialog;